<template>
    <div class="courses-single-page pb-4 pt-4">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div v-if="success" class="flat-row-half success">
                            <h1>Success!</h1>
                        <h2>
                            Reference: {{ transactionId  }}
                        </h2>
                        <p>Your payment was processed successfully, navigate to your dashboard to view and start your courses</p>
                        <br />
                        <router-link class="btn btn-site-primary" to="/dashboard">Go to my dashboard</router-link>
                    </div>
                    <div v-else-if="!success" class="flat-row-half fail">
                        <div>Transaction failed!</div>
                        <div>
                            Reference: {{ transactionId  }}
                        </div>
                        <br />
                        <router-link class="btn btn-site-secondary" to="/cart">Retry payment</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

    .courses-single-page .success h1 {
        font-size: 24px;
        line-height: 30px;
        font-weight: 500;
        color: #3bd524;
        margin-top: 20px;
        margin-bottom: 15px;
    }

    .courses-single-page .success h2 {
        font-size: 18px;
        line-height: 30px;
        font-weight: 500;
        color: #3bd524;
        margin-bottom: 15px;
    }

    .courses-single-page .success p {
    }

    .courses-single-page .fail h1 {
        font-size: 24px;
        line-height: 30px;
        font-weight: 500;
        color: #d82626;
        margin-top: 20px;
        margin-bottom: 15px;
    }

    .courses-single-page .fail h2 {
        font-size: 18px;
        line-height: 30px;
        font-weight: 500;
        color: #d82626;
        margin-bottom: 15px;
    }

    .courses-single-page .fail p {

    }
</style>

<script>

    export default {
        name: 'CartResult',
        components: {

        },
        data: function () {
            return {
                success: false
            }
        },
        computed: {
            transactionId() {
                return this.$route.query.reference;
            }
        },
        methods: {
            async pay() {


            },
        },
        async mounted() {
             
            const response = await this.web('/cart/PaymentResult?reference=' + this.transactionId);

            if (response.status == "Approved") {
                this.success = true;
                this.$store.commit("clearCart");
            }

            this.loadingProgress = false;

            var crumbs = {};
            crumbs["/cartresult"] = "Cart Result";
            this.$store.commit("breadCrumbs", crumbs);
        }
    }
</script>